import React from 'react'
import FrequencyForm from './FrequencyForm'
import { Range } from '@medeo/components'

const WeightTarget = () => (
  <div>
    <Range
      min={0}
      max={200}
      step={1}
      color="#FF5D5D"
      label="poids (kg)"
      items={[
        {
          low: 55,
          nameLow: 'weight-verylow',
          high: 130,
          nameHigh: 'weight-veryhigh',
          color: '#F19E40'
        },
        {
          low: 70,
          nameLow: 'weight-low',
          high: 120,
          nameHigh: 'weight-high',
          color: '#57DA92'
        }
      ]}
    />
    <FrequencyForm name="bodyWeight" />
  </div>
)

export default WeightTarget



// WEBPACK FOOTER //
// ./src/Goal/components/WeightTarget.js